'use client';

import React, { FunctionComponent, PropsWithChildren, useState } from 'react';
import { observer } from 'mobx-react';
import NavigateUpButton from '@/components/navigateUpButton/NavigateUpButton';
import CommunicationButton from '@/components/Communication/communicationModal/CommunicationButton';
import CommunicationModal from '@/components/Communication/communicationModal/CommunicationModal';
import { useAuth } from '@ibe/components';
import { configService } from '@/Config/config';

const Communication: FunctionComponent<PropsWithChildren> = observer(({ children }) => {
  const auth = useAuth();
  const isAgencyLoggedIn = auth.authState.isLoggedIn;

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return (
    <>
      <div className="page__blank" id="booking-summary-bar-container-anchor">
        {children}
      </div>
      <NavigateUpButton />
      {isAgencyLoggedIn && configService.get().showAgencyCommunication && (
        <div>
          <CommunicationButton
            onCommunicationButtonClickAction={() => {
              setIsModalOpen(true);
            }}
          />
          <CommunicationModal onDecline={() => setIsModalOpen(false)} isOpen={isModalOpen} />
        </div>
      )}
    </>
  );
});

export default Communication;
